// @flow

import React from "react";

import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";

import type { SyncAction } from "../types/sync_object";
type Props = {
  classes: Object,
  action: SyncAction,
  index: number,
  handleStringArrayFieldChange: Function,
  handleNumberArrayFieldChange: Function,
  handleBooleanArrayFieldChange: Function,
  handleDeepArrayFieldChange: Function,
  fieldHasError: Function,
  errorForField: Function,
  deleteAction: Function
};

const Action = (props: Props) => {

    return (
      <Grid item>
      <Card className={props.classes.actionCard}>
      <Grid container>
      <TextField
      label="Name"
      onChange={props.handleStringArrayFieldChange(
        "actions",
        props.index,
        "name",
        true
      )}
            margin="normal"
            className={props.classes.textField}
            value={props.action.name}
            error={props.fieldHasError(props.action, "name")}
            helperText={props.errorForField(props.action, "name")}
          />
          <TextField
            label="direction"
            onChange={props.handleStringArrayFieldChange(
                "actions",
                props.index,
                "direction",
                true
            )}
            margin="normal"
            className={props.classes.textField}
            value={props.action.direction}
            error={props.fieldHasError(props.action, "direction")}
            helperText={props.errorForField(props.action, "direction")}
          />
          <TextField
            label="Job class name"
            onChange={props.handleStringArrayFieldChange(
                "actions",
                props.index,
                "job_class_name",
                true
            )}
            className={props.classes.textField}
            margin="normal"
            value={props.action.job_class_name}
            error={props.fieldHasError(props.action, "job_class_name")}
            helperText={props.errorForField(props.action, "job_class_name")}
          />

          <TextField
            label="State valid for action method"
            onChange={props.handleStringArrayFieldChange(
                "actions",
                props.index,
                "state_valid_for_action_method",
            )}
            className={props.classes.textField}
            margin="normal"
            value={props.action.state_valid_for_action_method}
            error={props.fieldHasError(
                props.action,
                "state_valid_for_action_method"
            )}
            helperText={props.errorForField(
                props.action,
                "state_valid_for_action_method"
            )}
          />

          <TextField
            label="Queried attribute names"
            helperText="Use comma-separated values"
            onChange={props.handleDeepArrayFieldChange(
                "actions",
                props.index,
                "queried_attribute_names"
            )}
            margin="normal"
            className={props.classes.textField}
            value={props.action.queried_attribute_names}
            error={props.fieldHasError(
                props.action,
                "queried_attribute_names"
            )}
          />

          <Grid container>
            <Grid item xs={6}>
              <FormControlLabel
                className={props.classes.switch}
                control={
                  <Switch
                    checked={props.action.out_of_band}
                            onChange={props.handleBooleanArrayFieldChange(
                                "actions",
                                props.index,
                                "out_of_band"
                            )}
                            color="primary"
                  />
                }
                label="Out of band?"
              />
            </Grid>

            <Grid item xs={6}>
              <FormControlLabel
                className={props.classes.switch}
                control={
                  <Switch
                    checked={props.action.supports_batch}
                            onChange={props.handleBooleanArrayFieldChange(
                                "actions",
                                props.index,
                                "supports_batch"
                            )}
                            color="primary"
                  />
                }
                label="Supports batch?"
              />
            </Grid>
          </Grid>

          <TextField
            label="Out of Band Collection Method Name"
            onChange={props.handleStringArrayFieldChange(
                "actions",
                props.index,
                "out_of_band_collection_method_name",
            )}
            className={props.classes.textField}
            margin="normal"
            value={props.action.out_of_band_collection_method_name}
            error={props.fieldHasError(
                props.action,
                "out_of_band_collection_method_name"
            )}
            helperText={props.errorForField(
                props.action,
                "out_of_band_collection_method_name"
            )}
          />

          <TextField
            label="Out of band Query count"
            onChange={props.handleNumberArrayFieldChange(
                "actions",
                props.index,
                "out_of_band_query_count"
            )}
            margin="normal"
            className={props.classes.textField}
            value={props.action.out_of_band_query_count}
            error={props.fieldHasError(props.action, "out_of_band_query_count")}
            helperText={props.errorForField(
                props.action,
                "out_of_band_query_count"
            )}
          />

          <TextField
            label="Out of band position"
            onChange={props.handleNumberArrayFieldChange(
                "actions",
                props.index,
                "out_of_band_position"
            )}
            margin="normal"
            className={props.classes.textField}
            value={props.action.out_of_band_position}
            error={props.fieldHasError(props.action, "out_of_band_position")}
            helperText={props.errorForField(
                props.action,
                "out_of_band_position"
            )}
          />
        </Grid>
        <Grid container>
          <Grid item xs={10}>
            <FormControlLabel
              className={props.classes.switch}
              control={
                <Switch
                  checked={props.action.active}
                          onChange={props.handleBooleanArrayFieldChange(
                              "actions",
                              props.index,
                              "active"
                          )}
                          color="primary"
                />
              }
              label="Active?"
            />
          </Grid>
          <Grid item xs={2}>
            <IconButton
              aria-label="Delete"
              onClick={props.deleteAction(props.index)}
            >
              <DeleteIcon />
            </IconButton>
          </Grid>
        </Grid>
      </Card>
    </Grid>
  );
};

export default Action;



// WEBPACK FOOTER //
// ./src/lib/action.js